import { Component } from '@angular/core';
import { AddAttributeForm } from "../../../../components/admin-dashboard-component/attributes/add-attribute-form/add-attribute-form";

@Component({
  selector: 'app-add-attribute',
  imports: [AddAttributeForm],
  templateUrl: './add-attribute.html',
  styleUrl: './add-attribute.scss'
})
export class AddAttribute {

}
